import { render } from "./Tenant_Statement.vue?vue&type=template&id=3c61ad7c&scoped=true"
import script from "./Tenant_Statement.vue?vue&type=script&lang=js"
export * from "./Tenant_Statement.vue?vue&type=script&lang=js"

import "./Tenant_Statement.vue?vue&type=style&index=0&id=3c61ad7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c61ad7c"]])

export default __exports__